module.exports = new __parcel__URL__("CreateWithRovoSpotlightAnimation.1a1df728.gif").toString();